/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * Run `yarn nx run order:generate-types` and edit the `.graphql` files
 *
 * See codegen config in .graphqlrc.yml for details
 */

/* eslint-disable unicorn/no-abusive-eslint-disable */ /* eslint-disable eslint-comments/no-unlimited-disable */ /* eslint-disable */ /* cspell:disable */

import * as Types from '../../../graphql/types';

import { ExecutionResult } from 'graphql';
import gql from 'graphql-tag';
import { CustomerCreditsFragmentDoc } from '../../../graphql/fragments/CustomerData.generated';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetCustomerCreditQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type GetCustomerCreditQuery = {
  readonly __typename?: 'Query';
  readonly currentCustomer: {
    readonly __typename?: 'Customer';
    readonly id: string;
    readonly availableCredit: number;
    readonly useCredit: boolean;
    readonly credits: ReadonlyArray<{
      readonly __typename?: 'Credit';
      readonly id: string;
      readonly title: string;
      readonly description: string;
      readonly amount: number;
      readonly remainingAmount: number;
      readonly createdAt: string;
      readonly expiresAt: string | null;
    }>;
  } | null;
};

export const getCustomerCreditQueryMock: ExecutionResult<GetCustomerCreditQuery> =
  {
    data: {
      currentCustomer: {
        id: 'e509e6ea-9fee-442a-9962-587ce7190430',
        availableCredit: 4,
        useCredit: true,
        credits: [{}, {}, {}],
      },
    },
  };

export const GetCustomerCreditDocument = gql`
  query getCustomerCredit {
    currentCustomer {
      id
      availableCredit
      useCredit
      credits {
        ...customerCredits
      }
    }
  }
  ${CustomerCreditsFragmentDoc}
`;

export function useGetCustomerCreditQuery(
  options?: Omit<Urql.UseQueryArgs<GetCustomerCreditQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GetCustomerCreditQuery, GetCustomerCreditQueryVariables>(
    { query: GetCustomerCreditDocument, ...options },
  );
}
